import React from 'react'
import { useParams } from 'react-router-dom'

import { AcornsIcon } from '@acorns/icons'
import { Bodytext, Heading2 } from '@acorns/web-components'
import { useRemoteStrings } from '@acorns/web-utils'

import { CASH_OWED_BAR } from 'utils/testing/testIDs'

import { useCashOwedContext } from '../../../providers/CashOwed'
import { StyledCashOwedBar, StyledInfoIcon } from './styled-components'

const CashOwedBar = () => {
  const { getRemoteString } = useRemoteStrings()

  const {
    investCashOwed,
    earlyCashOwed,
    laterCashOwed,
    setIsCashOwedModalOpen,
  } = useCashOwedContext()

  const { beneficiaryId } = useParams<{ beneficiaryId: string }>()
  const isEarly = !!beneficiaryId
  const path = window.location.pathname
  const isLater = path.includes('later')

  const cashOwedAmount = () => {
    if (isEarly) {
      return earlyCashOwed
    } else if (isLater) {
      return laterCashOwed
    } else {
      return investCashOwed
    }
  }

  return (
    <StyledCashOwedBar
      onClick={() => setIsCashOwedModalOpen(true)}
      data-testid={CASH_OWED_BAR}
    >
      <Bodytext>
        {getRemoteString({ key: 'invest.cash_owed.title' })}
        <StyledInfoIcon
          icon={AcornsIcon.Icon.UtilityInfoRound}
          width={12}
          onClick={() => setIsCashOwedModalOpen(true)}
        />
      </Bodytext>
      <Heading2>${cashOwedAmount()}</Heading2>
    </StyledCashOwedBar>
  )
}

export default CashOwedBar
